export const resizeInput = (target, value?: number, reset?: boolean) => {
  if (reset) {
    target.style.removeProperty("height")
    target.style.height = `38px`
  } else {
    target.style.removeProperty("height")
    target.style.height = `${(target.scrollHeight || value) + 3}px`
  }
}
